import React, { Fragment, memo, useState } from 'react'
import { format } from 'date-fns'
import { de, fr } from 'date-fns/locale'
import Select from 'atpjs/components/form/select'
import i18n from 'atpjs/helpers/i18n'
import Rows from 'tve/components/appointment_grid/mobile/rows'
import WeekDisplay from 'tve/components/appointment_grid/week_display'
import { DAY_PATTERN } from 'tve/helpers/date'

const t = i18n.prefix(['components', 'appointmentGrid'])

const dateLocale = {
  de,
  fr
}

const Mobile = memo(
  ({ grid, nextHandler, previousHandler, handleBranchId, branchId, branchValues, value, onChange, selectBranch }) => {
    const startCell = grid[0][0]
    const endCell = grid[0][grid[0].length - 1]
    const [selectedColumn, setSelectedColumn] = useState(0)
    return (
      <Fragment>
        {branchValues.length > 1 && (
          <div className="atp-margin-top-xs">
            <Select
              onChange={handleBranchId}
              name="select2"
              values={branchValues}
              value={branchId}
              label={t(['whichBranch'])}
              hasEmpty={false}
            />
          </div>
        )}
        <div className="atp-time-header-wrapper atp-time-header-wrapper--fix ed">
          <div className="atp-time-week">
            <button type="button" className="atp-time-week__prev" disabled={!previousHandler} onClick={previousHandler}>
              &lt;
            </button>
            <WeekDisplay startCell={startCell} endCell={endCell} />
            <button type="button" className="atp-time-week__next" disabled={!nextHandler} onClick={nextHandler}>
              &gt;
            </button>
          </div>
          <ul className="atp-time-header">
            {grid[0].map((cell, columnIndex) => {
              const slotLength = grid.reduce((sum, row) => {
                return row[columnIndex].available ? sum + 1 : sum
              }, 0)
              const classes = ['atp-time-header__entry']
              if (columnIndex === selectedColumn) classes.push('atp-time-header__entry--current')
              if (slotLength === 0) classes.push('atp-time-header__entry--inactive')

              return (
                <li
                  className={classes.join(' ')}
                  key={format(cell.start, 'yyyy-MM-dd')}
                  onClick={slotLength > 0 ? () => setSelectedColumn(columnIndex) : null}>
                  <span className="atp-time-header__day">
                    {format(cell.start, 'EEEEEE', { locale: dateLocale[i18n.locale] })}
                  </span>
                  <span className="atp-time-header__date">{format(cell.start, DAY_PATTERN[i18n.locale])}</span>
                  <span className="atp-time-header__slots">{slotLength > 0 ? slotLength : '-'}</span>
                </li>
              )
            })}
          </ul>
        </div>
        <Rows
          grid={grid}
          selectedColumn={selectedColumn}
          value={value}
          onChange={onChange}
          branchId={branchId}
          selectBranch={selectBranch}
        />
      </Fragment>
    )
  }
)
Mobile.displayName = 'Mobile'

export default Mobile
